import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import PageContainer from '../../components/global/PageContainer';
import { withAuthorization, withOrganization } from '../../components/Session';
import AddAudioForm from '../../components/AddAudioForm';
import { withFirebase } from '../../components/Firebase';

const AddAudio = (props: any) => {
  const location = useLocation();
  const history = useHistory();
  const state = location.state as { fromJobId?: string } | undefined;
  const fromJobId = state?.fromJobId;

  return (
    <PageContainer>
      {fromJobId && (
        <div style={{
          marginBottom: '1rem', padding: '0.75rem 1rem',
          backgroundColor: 'rgba(255, 180, 50, 0.1)', borderRadius: '6px',
          border: '1px solid rgba(255, 180, 50, 0.3)',
          color: '#ffb432', fontSize: '0.9rem',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        }}>
          <span>Uploading spots for a campaign. After saving, you'll be redirected back to match tracks.</span>
          <button
            onClick={() => history.push(`/jobs/${fromJobId}`)}
            style={{ background: 'none', border: 'none', color: '#ffb432', cursor: 'pointer', textDecoration: 'underline', fontSize: '0.85rem' }}
          >
            Back to Job
          </button>
        </div>
      )}
      <AddAudioForm firebase={props.firebase} onSaveComplete={fromJobId ? () => {
        history.push(`/jobs/${fromJobId}`, { autoMatch: true });
      } : undefined} />
    </PageContainer>
  );
};

// Only check that user is authenticated - org role check is handled by withOrganization
// and the Navigation component already hides this link for non-ADMIN/OPERATOR users
const condition = (authUser: any) => !!authUser;
export default withOrganization(withAuthorization(condition)(withFirebase(AddAudio)));
